"use client";
import { useState } from "react";
import Image from "next/image";
import YearsInBusinessImg from "@/Helper/images/new/years_in_business.png";
import TeamskilledMembersImg from "@/Helper/images/new/team_members.png";
import LocationsImg from "@/Helper/images/new/locations.png";

const businessStats = [
  {
    imgSrc: YearsInBusinessImg,
    count: "180+",
    title: "Years in business",
    title2: "Successful years",
    description: 'S.S. White is one of the oldest manufacturing companies in the United States. We were founded in 1844. We are featured in the book, " Middlesex County : Crossroads of History" as a manufacturing company with a unique and fabled history.',
  },
 
  {
    imgSrc: TeamskilledMembersImg,
    count: "275+",
    title: "Skilled Team Members",
    title2: "Team Members",
    description: "Our skilled team members specialize in flexible shaft technology, providing customized solutions for various industrial needs. With expertise in design and application, they ensure optimal performance and reliability in every project.",
  },
  {
    imgSrc: LocationsImg,
    count: "3+",
    title: "Locations",
    title2: "Locations",
    description: "Our branch locations are strategically placed to serve you efficiently, offering local expertise and support. With accessible offices, we ensure prompt service and tailored solutions for all your needs.",
  },
];

const BusinessHistory = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="hm_sectionbx">
      <div className="container">
        <div className="hm_sectionbxouterrow">
          <div className="hm_sectionbxouter col-md-12">
            <div className="hm_sectionbxinner cards">
              {businessStats.map((item, index) => (
                <div
                  key={index}
                  className={`hm_sectionbxlist ${
                    index === activeIndex ? "hm_sectionbxlist_active" : ""
                  }`}
                  
                  onMouseOver={() => setActiveIndex(index)}
                >
                  <div className="hmsectionlisttop">
                    <Image
                      className="lazy-image"
                      src={item.imgSrc}
                      alt={item.title}
                      width={635}
                      height={418}
                      loading="lazy"
                    />
                    <div className="hmsectionlisttopinner card_infos">
                      <p className="prlist_heading">{item.count}</p>
                      <p className="prlist_heading2">{item.title}</p>
                      <p className="prlist_content">{item.description}</p>
                    </div>
                  </div>
                  <div className="hmsectionlistbottom">
                    <p className="hmsectionlistbottomcont">{item.title2}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessHistory;
